module.exports = __webpack_public_path__ + "static/media/godOfMars-3.975f1c38.png";